import { RouterProvider } from 'react-router-dom';
import { router } from './Routes/Routes';
import { TenantProvider } from './Contexts/TenantContext';
import { AuthProvider } from './Contexts/AuthContext';
import { CartProvider } from './Contexts/CartContext';
import { AdminNotificationProvider } from './Contexts/AdminNotificationContext';
import AppToastContainer from './Components/AppToastContainer/AppToastContainer';
import React from 'react';
import ReactDOM from 'react-dom/client';
import reportWebVitals from './reportWebVitals';
import 'react-toastify/dist/ReactToastify.css';
import './index.css';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <TenantProvider>
      <AuthProvider>
        <CartProvider>
          <AdminNotificationProvider>
            <RouterProvider router={router} />
          </AdminNotificationProvider>
          <AppToastContainer />
        </CartProvider>
      </AuthProvider>
    </TenantProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
